module.exports = __webpack_public_path__ + "static/5-7b85eb96db583084ce199c2b9528ab77.jpg";